import { colorSamplesTypes } from 'services/utils/const';

export const getColorSamplesItemsPrice = (order, prices) => {
  let colorSamplesItemsPrice = 0;
  const colorSamplesItems = order.colorSamplesItems.map((item, index) => {
    console.log(`ELEMENT: ${index + 1}`);
    let itemPrice = 0;
    const setItemPrice = (value) => (itemPrice = value);

    item = handleColorSampleItem(order, item, setItemPrice, prices);

    colorSamplesItemsPrice += itemPrice || 0;
    return item;
  });
  return { colorSamplesItemsPrice, colorSamplesItems };
};

const handleColorSampleItem = (order, item, setItemPrice, prices) => {
  const { type, quantity } = item;
  if (order.orderType.toLowerCase() === 'reklamacja (wina blow)') {
    setItemPrice(0);
  }

  item.includedToPrice = true;
  if (type === colorSamplesTypes.METAL_SHEET_2MM.type) {
    if (order.paintType === 'połysk' || order.transparent) {
      const price =
        quantity * prices.colorSamples.metalPlate.secondPriceGroup;
      setItemPrice(price);
      console.log(`${type} - połysk/woda | ${quantity} | ${price}`);
      return item;
    } else if (order.paintType === 'mat' || order.paintType === 'półmat') {
      const price =
        quantity * prices.colorSamples.metalPlate.firstPriceGroup;
      setItemPrice(price);
      console.log(`${type} - mat/półmat | ${quantity} | ${price}`);
      return item;
    }
  } else if (type === colorSamplesTypes.MDF_6MM.type) {
    if (order.paintType === 'połysk' || order.transparent) {
      const price = quantity * prices.colorSamples.mdf6mm.secondPriceGroup;
      setItemPrice(price);
      console.log(`${type} - połysk/woda | ${quantity} | ${price}`);
      return item;
    } else if (order.paintType === 'mat' || order.paintType === 'półmat') {
      const price = quantity * prices.colorSamples.mdf6mm.firstPriceGroup;
      setItemPrice(price);
      console.log(`${type} - mat/półmat | ${quantity} | ${price}`);
      return item;
    }
  } else if (type === colorSamplesTypes.MDF_19MM.type) {
    if (order.paintType === 'mat' || order.paintType === 'półmat') {
      const price =
        quantity * prices.colorSamples.mdfMilled.firstPriceGroup;
      setItemPrice(price);
      console.log(`${type} - mat/półmat | ${quantity} | ${price}`);
      return item;
    }
  }
  setItemPrice(0);
  item.includedToPrice = false;
  console.log(`${type} - nie wliczane w cenę | ${quantity} | 0`);
  return item;
};
